
interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm' : 'bg-transparent'
      }`}
    >
      <nav className="max-w-[1400px] mx-auto px-8 py-6 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <img 
            src="https://public.readdy.ai/ai/img_res/ea83de06-5686-4a60-8635-feacfafa3b53.png" 
            alt="METOS DOO NIS Logo" 
            className="h-10 w-10 object-contain"
          />
          <h1 className="text-xl font-semibold text-gray-900">METOS DOO NIS</h1>
        </div>
        <ul className="flex items-center gap-10">
          <li>
            <button
              onClick={() => scrollToSection('home')}
              className="text-sm font-light uppercase tracking-wide text-gray-700 hover:text-gray-900 transition-colors relative group cursor-pointer whitespace-nowrap"
            >
              HOME
              <span className="absolute bottom-0 left-0 w-0 h-px bg-gray-900 transition-all duration-300 group-hover:w-full"></span>
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection('about')}
              className="text-sm font-light uppercase tracking-wide text-gray-700 hover:text-gray-900 transition-colors relative group cursor-pointer whitespace-nowrap"
            >
              ABOUT
              <span className="absolute bottom-0 left-0 w-0 h-px bg-gray-900 transition-all duration-300 group-hover:w-full"></span>
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection('products')}
              className="text-sm font-light uppercase tracking-wide text-gray-700 hover:text-gray-900 transition-colors relative group cursor-pointer whitespace-nowrap"
            >
              PRODUCTS
              <span className="absolute bottom-0 left-0 w-0 h-px bg-gray-900 transition-all duration-300 group-hover:w-full"></span>
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection('features')}
              className="text-sm font-light uppercase tracking-wide text-gray-700 hover:text-gray-900 transition-colors relative group cursor-pointer whitespace-nowrap"
            >
              FEATURES
              <span className="absolute bottom-0 left-0 w-0 h-px bg-gray-900 transition-all duration-300 group-hover:w-full"></span>
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-sm font-light uppercase tracking-wide text-gray-700 hover:text-gray-900 transition-colors relative group cursor-pointer whitespace-nowrap"
            >
              CONTACT
              <span className="absolute bottom-0 left-0 w-0 h-px bg-gray-900 transition-all duration-300 group-hover:w-full"></span>
            </button>
          </li>
        </ul>
      </nav>
    </header>
  );
}